import {
  buildQueueOverviewModel,
  formatQueueDateTime,
} from '../../../data/moderationQueueSpec';

/**
 * Screen 2 Overview model — spec data for the existing FieldRow layout.
 */
export function buildModerationOverviewModel({
  scenario,
  itemFromState,
  formatDateTime = formatQueueDateTime,
}) {
  return buildQueueOverviewModel({
    scenario,
    itemFromState,
    formatDateTime,
  });
}
